<template>
  <dl class="search-field mb-0">
    <dt>
      <!-- IME (中国語、日本語、韓国語、その他) が必須な言語において、v-model では IME でテキストが確定するまでは更新されないことに注意してください。
  これらの更新に対して対応したい場合は、input イベントを代わりに使用します。 -->
      <input
        :id="inputId"
        :value="selection"
        :name="inputName"
        type="text"
        class="form-control search-box font-default pl-7"
        :class="{
          'form-control-lg': formSize === 'lg',
          'form-control-sm': formSize === 'sm',
          'bg-gray01': isBackgroundGray,
          'search-field-width': searchFieldWidth,
          'company-search-field-width': companySearchFieldWidth,
          'bg-white': isInputBackColorWhite
        }"
        :placeholder="placeholder"
        autocomplete="off"
        @input="onInput"
        @keydown.enter="onEnter"
        @keydown.down="onDown"
        @keydown.up="onUp"
        @focus="onFocus"
        @blur="onBlur"
      >
      <i class="material-icons text-gray02 search-icon ml-1 cursor-default">search</i>
    </dt>
    <dd>
      <button
        v-if="selection !== ''"
        type="button"
        class="cancel-btn position-absolute"
        @click="deleteText"
      >
        <i class="material-icons text-gray04"> cancel </i>
      </button>
      <div
        v-if="loading"
        class="loading-indicator position-absolute"
      >
        <img
          src="https://i.imgur.com/mTNe6tr.gif"
          class="loading-indicator-img"
        >
      </div>
    </dd>
    <ul
      ref="ulElement"
      class="dropdown-menu border m-0 w-100"
      :class="{
        'show': openSuggestion,
        'font-large': listFontSize === 'lg',
        'font-small': listFontSize === 'sm',
        'position-relative': isAdminSignUp,
        'vertical-scroll-only': isAdminSignUp,
        'search-field-width': searchFieldWidth,
        'company-search-field-width': companySearchFieldWidth,
        'width-800' : isProjectSearch && suggestions.length
      }"
      :style="scrollStyle"
      @mouseover="onMouseover"
      @mouseleave="onMouseleave"
    >
      <div v-if="isAdminSignUp && suggestions.length">
        <div
          v-if="companyLimit == 'limited'"
          class="m-3 red-text"
        >
          {{ t('msg.company_limit_message') }}
        </div>
        <div
          v-else-if="companyLimit == 'unlimited'"
          class="m-3"
        >
          {{ suggestions.length }}{{ t("cases") }}
        </div>
        <p class="m-3">
          {{ t('msg.select_from_the_following') }}
        </p>
      </div>
      <h6
        v-else
        class="dropdown-header"
        :class="{
          'pl-3' : isAdminSignUp,
          'd-none' : resultText === ''
        }"
      >
        {{ resultText }}
      </h6>
      <li
        v-for="(data, index) in suggestions"
        :key="data.id"
        class="dropdown-item p-0"
        :class="{
          'active': isActive(index),
          'admin-registration-dropdown': isAdminSignUp
        }"
        @click="suggestionClick(index)"
      >
        <a
          v-if="isAdminSignUp"
          class="admin-company-card p-3"
        >
          <div class="row">
            <div class="col-3 pr-1">
              <img
                v-if="data.logo == undefined"
                class="d-inline company-icon w-100"
                :src="noLogo"
              >
              <img
                v-else
                class="d-inline company-icon w-100"
                :src="data.logo"
              >
            </div>
            <div class="col-9 pl-1">
              <p class="mb-1">
                {{ data.name }}
              </p>
              <a
                :href="data.url"
                class="url-link"
                target="_blank"
                @click.stop
              >
                <span class="font-extrasmall">
                  {{ data.url }}
                  <i class="material-icons md-18">open_in_new</i>
                </span>
              </a>
            </div>
          </div>
        </a>
        <a
          v-else-if="isCompanySearch"
          class="py-1 px-4 text-default"
          :href="basePath + '/' + data.id"
        >
          {{ data.name }}
        </a>
        <a
          v-else-if="isCustomerCompanySearch"
          class="py-1 px-4 text-default"
        >
          {{ data.name }}
        </a>
        <a
          v-else-if="isProjectSearch"
          class="py-1 px-4 text-default text-black"
          :href="`${basePath}?id=${data.id}`"
        >
          {{ projectSuggestionList(data) }}
        </a>
        <a
          v-else
          class="py-1 px-4"
        >
          {{ data.name }}
        </a>
      </li>
      <a
        v-if="isAdminSignUp"
        class="d-inline-block m-3 mb-4 text-commit-blue"
        @click="type3"
      >
        {{ t("click_here_if_cannot_find") }}
      </a>
      <a
        v-if="isCustomerCompanySearch"
        :href="linkPath"
        class="d-inline-block m-3 mb-4 text-commit-blue"
        target="_blank"
      >
        {{ t("create_new_company") }}
        <i class="material-icons md-16 md-align-n4 d-inline">open_in_new</i>
      </a>
    </ul>
  </dl>
</template>

<script>
import axios from "axios";
import I18n from "../../i18n/i18n";
import "../../i18n/ja";
import _ from "lodash";
import { i18n } from "../../mixins/i18n";
import moment from "moment";

export default {
  mixins: [i18n],
  props: {
    isCompanySearch: {
      type: Boolean,
      default: true
    },
    isCustomerCompanySearch: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      default() {
        return {};
      }
    },
    basePath: {
      type: String,
      default: ""
    },
    inputId: {
      type: String,
      default: "input-id"
    },
    inputName: {
      type: String,
      default: "input-name"
    },
    placeholder: {
      type: String,
      default: "search"
    },
    defaultInput: {
      type: String,
      default: ""
    },
    formSize: {
      type: String,
      default: "md"
    },
    listFontSize: {
      type: String,
      default: "md"
    },
    scrollLimitHeight: {
      type: String,
      default: "300px"
    },
    isAdminSignUp: {
      type: Boolean,
      default: false
    },
    isShowResultText: {
      type: Boolean,
      default: true
    },
    isBackgroundGray: {
      type: Boolean,
      default: true
    },
    searchFieldWidth: {
      type: Boolean,
      default: true
    },
    companySearchFieldWidth: {
      type: Boolean,
      default: false
    },
    isProjectSearch: {
      type: Boolean,
      default: false
    },
    linkPath: {
      type: String,
      default: ""
    },
    customResultText: {
      type: String,
      default: ""
    },
    isInputBackColorWhite: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selection: this.defaultInput,
      subSelection: this.defaultInput,
      show: false,
      loading: false,
      skip: false,
      onListFlg: false,
      current: -1,
      suggestions: [],
      waitTime: 500,
      resultText: "",
      scrollStyle: {
        overflow: "scroll",
        "max-height": this.scrollLimitHeight
      },
      companyLimit: "none",
      noLogo: require("../../../../assets/images/no_logo.jpeg"),
      name: "",
      companyName: "",
      companyUrl: "",
      displayResultText: true,
      subject: this.customResultText || I18n.t("member")
    };
  },
  computed: {
    openSuggestion() {
      return this.show;
    },
    projectSuggestionList() {
      return function(data) {
        const format = "YYYY/MM/DD";

        return `${data.name} | ${data.uuid} (${moment(data.start_date).format(format)} ~ ${moment(data.end_date).format(format)})`;
      };
    }
  },
  watch: {
    selection() {
      if (this.selection !== "") {
        this.loading = true;
      } else {
        this.show = false;
      }
      this.debouncedGetAnswer();
    }
  },
  created() {
    this.debouncedGetAnswer = _.debounce(this.getSuggestions, this.waitTime);
  },
  mounted() {
    axios.defaults.headers["X-CSRF-TOKEN"] = document.getElementsByName("csrf-token")[0].content;
    axios.defaults.headers.X_REQUESTED_WITH = "XMLHttpRequest";
    if (this.selection !== "") {
      this.getSuggestions("firstTime");
    }
  },
  methods: {

    // When the user changes input
    onInput(event) {
      this.selection = event.target.value;
      this.$emit("input", this.selection);
    },

    // When enter pressed on the input
    onEnter() {
      const targets = this.$refs.ulElement.children;

      if (this.hasActive(targets)) {
        this.skip = true;
        this.selection = this.suggestions[this.current].name;
      }
      this.$emit("enter");
    },

    // When up pressed while suggestions are open
    onUp() {
      this.skip = true;
      if (this.current === -1) {
        this.current = this.suggestions.length - 1;
        this.selection = this.suggestions[this.current].name;
      } else if (this.current - 1 >= 0 && this.current - 1 <= this.suggestions.length - 1) {
        this.current--;
        this.selection = this.suggestions[this.current].name;
      } else {
        this.current = -1;
        this.selection = this.subSelection;
      }
      this.$emit("up");
    },

    // When up pressed while suggestions are open
    onDown() {
      this.skip = true;
      if (this.current + 1 <= this.suggestions.length - 1 && this.current + 1 >= -1) {
        this.current++;
        this.selection = this.suggestions[this.current].name;
      } else {
        this.current = -1;
        this.selection = this.subSelection;
      }
      this.$emit("down");
    },

    // For highlighting element
    isActive(index) {
      return index === this.current;
    },

    // focus input
    onFocus() {
      if (this.selection !== "" && this.displayResultText) {
        this.show = true;
      }
      this.$emit("focus");
    },

    // blur input
    onBlur() {
      if (!this.onListFlg) {
        this.show = false;
      }
      this.$emit("blur");
      if (this.inputName === "company_name" && this.selection === "") {
        this.$emit("input-delete");
      }
    },

    // When one of the suggestion is clicked
    suggestionClick(index) {
      this.skip = true;
      this.selection = this.isProjectSearch ? this.suggestions[index].uuid : this.suggestions[index].name;
      this.show = false;
      this.$emit("suggestion-click", this.suggestions[index].id, this.suggestions[index]);
    },

    // ajax for get suggestions
    getSuggestions(timing) {
      if (this.skip) {
        this.skip = false;
        this.loading = false;
        return;
      }
      const selection = this.selection;

      if (selection === "") {
        this.suggestions = [];
        this.loading = false;
        this.show = false;
        return;
      }
      const resetParams = this.getParams(selection);

      // HACK: 要リファクタリング
      axios.post(this.path, resetParams).then(response => {
        if (response.status === 200) {
          this.suggestions = response.data;
          this.subSelection = selection;
          this.resultText = this.isShowResultText ? I18n.t("search_results") : "";
          this.displayResultText = true;
          if (this.isAdminSignUp) {
            this.companyLimit = this.suggestions.length === 20 ? "limited" : "unlimited";
          }
          if (!this.suggestions.length) {
            if (this.isCompanySearch && !this.isAdminSignUp) {
              this.show = false;
              this.displayResultText = false;
            } else {
              this.resultText = I18n.t("msg.not_found_by_request", { v: this.subject });
            }
          }
          if (!timing && this.displayResultText) {
            this.show = true;
          }
          this.loading = false;
        }
      });
    },

    // params for search companies
    getParams(name) {
      if (this.isCompanySearch) {
        return {
          name,
          sort: this.params.sort,
          prefectures: this.params.prefectures,
          // eslint-disable-next-line camelcase
          business_categories: this.params.business_categories,
          // eslint-disable-next-line camelcase
          industry_tags: this.params.industry_tags,
          // eslint-disable-next-line camelcase
          service_tags: this.params.service_tags
        };
      }
      return { name };
    },

    // return boolean if array has active in class
    hasActive(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].classList.contains("active")) {
          return true;
        }
      }
      return false;
    },

    // delete input text
    deleteText() {
      this.selection = "";
      this.skip = true;
      this.$emit("delete");
      if (this.inputName === "company_name") {
        this.$emit("input-delete");
      }
    },

    // mouse on the suggest list
    onMouseover() {
      this.onListFlg = true;
      this.$emit("mouseover");
    },

    // mouse leave the suggest list
    onMouseleave() {
      this.onListFlg = false;
      this.$emit("mouseover");
    },
    type3() {
      this.$emit("click-type3");
    }
  }
};

</script>

<style lang="scss" scoped>
dl.search-field {
  position: relative;
  border-radius: 4.2px;
  dt {
    input {
      height: 40px;
      background: none;
      cursor: text;
      &:focus {
        border: 1px solid #65b1fc;
      }
    }
  }
  dd {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    .cancel-btn,
    .loading-indicator {
      top: 50%;
      display: block;
      padding: 10px 3px 10px 10px;
      background: none;
      border: none;
      transition-property: color;
      border-style: none;
      background-color: transparent;
    }
    .cancel-btn {
      right: 10px;
      transform: translateY(-50%);
    }
    .loading-indicator {
      right: 45px;
      transform: translateY(-54%);
    }
  }
}
.search-box {
  height: 40px;
  &::placeholder {
    color: #8A929A;
  }
}
.search-icon {
  position: absolute;
  top: 52%;
  transform: translateY(-50%);
}
a {
  display: block;
  width: 100%;
}
.loading-indicator-img {
  width: 20px;
  margin-right: 5px;
}
.admin-contents {
  li.dropdown-item {
    &.active {
      background: #F7F8FA!important;
      color: #282828;
    }
    & a:hover {
      color: #282828;
    }
    &:hover {
      background: #F7F8FA!important;
      color: #282828;
    }
  }
}
li.dropdown-item {
  & a:hover {
    transition:all 0s!important;
  }
}
.admin-company-card {
  display: block;
  color: #282828!important;
  transition: all 0.2s ease-in-out;
}
.url-link {
  text-decoration: none;
  color: #282828;
  margin-bottom: .5rem;
  :hover {
    color: #0080fc!important;
  }
}
.admin-registration-dropdown {
  white-space: normal;
}
.vertical-scroll-only {
  overflow-x: hidden !important;
}
@media (min-width: 1040px) {
  .width-800 {
    width: 800px !important;
  }
}
</style>
